import { Check } from 'lucide-react';

export type TabState = 'active' | 'done' | 'default' | 'locked';

export interface Tab {
  id: string;
  label: string;
  state: TabState;
}

export function TabStrip({ tabs, onSelect }: { tabs: Tab[]; onSelect: (id: string) => void }) {
  return (
    <div className="flex gap-2 overflow-x-auto pb-1">
      {tabs.map((tab) => {
        const tone =
          tab.state === 'active'
            ? 'bg-brand-600 text-white'
            : tab.state === 'locked'
              ? 'bg-slate-100 text-slate-400'
              : 'bg-brand-50 text-brand-700 hover:bg-brand-100';

        return (
          <button
            key={tab.id}
            type="button"
            disabled={tab.state === 'locked'}
            onClick={() => onSelect(tab.id)}
            className={`inline-flex shrink-0 items-center gap-1.5 rounded-full px-3.5 py-1.5 text-xs font-bold uppercase tracking-wide transition ${tone}`}
          >
            {tab.state === 'done' && <Check size={12} />}
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
